import { makeContextModule } from '@cian/react-utils';

import { type MapAppContext } from '@/microfrontends/map/shared/types/mapAppContext';

export const {
  Context: { Provider: MapAppContextProvider },
  useContext: useMapAppContext,
} = makeContextModule<MapAppContext>({
  contextName: 'MapAppContext',
});
